<template>
    <v-content>
        <div>
            <v-breadcrumbs :items="snackbar.breadcrumbItems" large></v-breadcrumbs>
            <div slot="table-actions">
                <div class="my-1">
                    <v-btn color="primary" @click.stop="addModal">Company Form</v-btn>
                </div>
            </div>
            <vue-good-table
                    :columns="columns"
                    :rows="rows"
                    mode="remote"
                    :totalRows="companyData.totalRecords"
                    :pagination-options="{ enabled: true,mode: 'records' }"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    styleClass="vgt-table condensed"
            >
                <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'establishedYear'">
                  <span>{{props.row.establishedYear | moment("DD-MMM-YYYY")}}</span>
                </span>
                    <span v-else-if="props.column.field == 'actions'">
                  <v-icon small class="mr-2" @click.stop="editItem(props.row)">edit</v-icon>
                  <v-icon small @click="deleteItem(props.row)">delete</v-icon>
                </span>
                </template>
            </vue-good-table>
            <v-dialog
                    v-model="snackbar.formModal"
                    max-width="800"
                    transition="dialog-bottom-transition"
                    persistent
            >
                <v-card>
                    <CompanyForm @dialogueClose="dialogueClose"
                                        @formResponse="formResponse"
                                        v-if="snackbar.createFormComponent"
                    ></CompanyForm>
                    <CompanyEditForm @dialogueClose="dialogueClose"
                                            @formResponse="formResponse"
                                            v-if="snackbar.editFormComponent"
                                            :editItemIndex="companyData.editItemIndex"
                    ></CompanyEditForm>
                </v-card>
            </v-dialog>
            <v-snackbar
                    v-model="snackbar.snackbar"
                    :color="snackbar.color"
                    :timeout="snackbar.timeout"
                    top
            >
                {{ snackbar.text }}
                <v-btn
                        dark
                        text
                        @click="snackbar.snackbar = false"
                >
                    Close
                </v-btn>
            </v-snackbar>
            <v-dialog v-model="snackbar.dialogDelete" max-width="500px">
                <deleteListData :deleteFormData="companyData.deleteFormData"
                                @formResponse="onResponseDelete"></deleteListData>
            </v-dialog>
        </div>
    </v-content>
</template>

<script>
    import axios from "axios";
    import CompanyForm from "./CompanyForm";
    import CompanyEditForm from "./CompanyEditForm";
    import deleteListData from "@/components/deleteModal";
    import {mapGetters} from "vuex";

    export default {
        name: "CompanyList",
        components: {
            'CompanyForm': CompanyForm,
            'CompanyEditForm': CompanyEditForm,
            'deleteListData': deleteListData
        },
        data() {
            return {
                role:this.$store.getters.getUserRole,
                columns: [
                    {
                        label: 'Name',
                        field: 'name',
                    },
                    {
                        label: 'Code',
                        field: 'code',
                    },
                    {
                        label: 'Address',
                        field: 'address',
                    },
                    {
                        label: 'Phone Number',
                        field: 'phoneNumber',
                    },
                    {
                        label: 'Email',
                        field: 'email',
                    },
                    {
                        label: 'Website',
                        field: 'website',
                    },
                    {
                        label: 'Established Year',
                        field: 'establishedYear',
                    },
                    {label: "Actions", field: "actions"}
                ],
                rows: [],
                companyData: {
                    totalRows: 0,
                    editItemIndex: null,
                    deleteFormData: {}
                },
                serverParams: {
                    search: "",
                    columnFilters: {},
                    sort: [
                        {
                            field: "companyID",
                            type: "desc"
                        }
                    ],
                    page: 1,
                    perPage: 10
                },
                snackbar: {
                    color: '',
                    snackbar: false,
                    text: '',
                    timeout: 6000,
                    isLoading: false,
                    formModal: false,
                    createFormComponent: false,
                    editFormComponent: false,
                    dialogDelete: false,
                    breadcrumbItems: [
                        {
                            text: 'Dashboard',
                            disabled: false,
                            to: '',
                            exact: true
                        },
                        {
                            text: 'Company List',
                            disabled: true,
                        },
                    ],
                    dynamicComponent: {
                        current: 'CompanyForm'
                    }
                }
            };
        },
        methods: {
            loadBreadCrumbs(){
                this.snackbar.breadcrumbItems[0].to = this.userRole.toLowerCase() + "Dashboard"

            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.loadItems();
            },

            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params[0].type,
                        field: params[0].field,
                    }],
                });
                this.loadItems();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },

            addModal() {
                this.snackbar.formModal = true
                this.snackbar.createFormComponent = true
            },

            editItem(item) {
                this.snackbar.formModal = true
                this.snackbar.editFormComponent = true
                this.companyData.editItemIndex = item.companyID
            },

            deleteItem(item) {
                this.snackbar.dialogDelete = true;
                console.log(item)
                this.companyData.deleteFormData.url = "Company/Delete/" + item.companyID;
                this.loadItems();
            },

            onResponseDelete( responseObj ) {
                this.snackbar.dialogDelete = false;
                this.snackbar.color = responseObj.color ? responseObj.color : 'red'
                this.snackbar.text = responseObj.message ? responseObj.message : 'Server Error'
                this.snackbar.snackbar = true
                this.loadItems();
            },

            formResponse(responseObj) {
                this.snackbar.color = responseObj.color ? responseObj.color : 'red'
                this.snackbar.text = responseObj.message ? responseObj.message : 'Server Error'
                this.snackbar.snackbar = true
                this.loadItems();
            },

            dialogueClose() {
                this.companyData.editItemIndex = null
                this.snackbar.formModal = false
                this.snackbar.createFormComponent = false
                this.snackbar.editFormComponent = false
                this.loadItems()
            },

            async loadItems() {
                this.snackbar.breadcrumbItems[0].to = this.role == "SuperAdmin"?"superAdminDashboard":this.role == "Company"?"companyDashboard":this.role == "Department"?"departmentDashboard":"branchDashboard"
                this.snackbar.isLoading = true;
                let param = {
                    PageSize: this.serverParams.perPage,
                    PageNo: this.serverParams.page,
                    OrderType: this.serverParams.sort[0].type,
                    OrderBy: this.serverParams.sort[0].field,
                    isActive : true
                };
                const companyData = await axios.post('Company/CompanyList', param)
                this.rows = companyData.data.data
                this.snackbar.loading = false;
            },
        },
        mounted() {
            this.loadItems()
        },
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
        },

    }
</script>

<style scoped>

</style>
